/* eslint-disable */
export class Conf {
    static idempiereUrl = "https://idempiere.vecositalia.it/"
    static windowTitle = 'CERTIFICO'
    static buildNo = "20251222112431"
}